// @ts-nocheck
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

const useShipTo = () => {
    const session = useSelector(getSession);
    return session.shipToId;
};

export default useShipTo;
